import React from 'react';
export function PivotSection() {
  return <section className="py-24 px-4 bg-brand-purple text-center relative overflow-hidden" data-id="element-165">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-166"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-167">
        <p className="text-brand-yellow font-bold text-2xl md:text-3xl mb-6 tracking-wide" data-id="element-168">
          La buena noticia:
        </p>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-8 leading-tight" data-id="element-169">
          Con el sistema correcto, <br className="hidden md:block" data-id="element-170" /> 20 minutos
          alcanzan.
        </h2>
        <p className="text-xl md:text-2xl text-brand-purpleLight font-medium max-w-2xl mx-auto" data-id="element-171">
          Tu air fryer es la herramienta perfecta. Solo le faltaban las
          instrucciones adecuadas.
        </p>
      </div>
    </section>;
}